// The few colours the diagram picks for itself, rather than reading from data.
//
// Every one of these is a FALLBACK. Path and sphere colours are King/Queen
// scale values and are never chosen here — that colour is data, and recolouring
// a path throws away a correspondence. What is left is: what to draw a group in
// when the seed row has no colour_hex, what to draw a sequence in when its
// first group has none, and the one colour that is a statement rather than a
// fallback — the Abyss.
export const GROUP_FALLBACK = "#E8E3D9";
export const SEQUENCE_FALLBACK = "#F2C300";

// The Binah-to-Chesed leap has NO path under it. It is drawn dashed, in a
// colour used for nothing else on the diagram, because "there is no path here"
// is the single most interesting thing an overlay says.
export const ORPHAN = "#F04E23";

// The neutral fill for a node in a tradition with no colour scales at all.
export const UNSCALED_SPHERE = "#4a5160";

export const groupColour = (group) => (group && group.colorHex) || GROUP_FALLBACK;

export const sequenceColour = (overlay) =>
  (overlay && overlay.groups[0] && overlay.groups[0].colorHex) || SEQUENCE_FALLBACK;
